export const URL_BASE = 'https://centaracare.com/';
